export const USAGE_TYPE_GERMAN_NAME: Record<AssemblyTypes, string> = {
  Inner: 'Innenwand',
  Outer: 'Außenwand',
  Ceiling: 'Decke',
  Roof: 'Dach',
}

export const serializeAssemblyForClipboard = (assembly: Assembly): string =>
  JSON.stringify(assembly, null, 2)

export const isAssemblyClipboardPayload = (value: unknown): value is Assembly => {
  if (!value || typeof value !== 'object') return false

  const candidate = value as Partial<Assembly>

  return (
    typeof candidate.name === 'string' &&
    typeof candidate.usage_type === 'string' &&
    typeof candidate.kind === 'string' &&
    Array.isArray(candidate.layers)
  )
}

export const parseAssemblyFromClipboardText = (text: string): Assembly | null => {
  if (!text.trim()) return null

  try {
    const parsed: unknown = JSON.parse(text)
    return isAssemblyClipboardPayload(parsed) ? parsed : null
  } catch {
    return null
  }
}

export const preparePastedAssembly = (assembly: Assembly): Assembly => ({
  ...assembly,
  guid: crypto.randomUUID(),
  name: `${assembly.name} (Kopie)`,
  isStandard: false,
})
